<template>
  <v-card>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="4">
          <p class="text-caption">Edit values or paste them.</p>
        </v-col>
        <v-spacer />
        <v-col>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn width="90" height="30" small v-on="on" @click="copyValues()" outlined>
                <v-icon small>mdi-content-copy</v-icon>
                Copy
              </v-btn>
            </template>
            <span>Copy values</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <v-col>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn width="90" height="30" small v-on="on" @click="pasteValues" outlined>
                <v-icon small>mdi-content-paste</v-icon>
                Paste
              </v-btn>
            </template>
            <span>Paste values</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-simple-table dense>
        <template #default>
          <thead>
            <tr>
              <th
                v-for="(header, headerIndex) in headers"
                :key="`header-${headerIndex}`"
                class="text-left"
              >
                {{ header.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rIndex) in tableValue" :key="`row-${rIndex}`">
              <td v-for="(header, hIndex) in headers" :key="`col-${hIndex}`">
                <v-text-field
                  v-if="header.editable"
                  type="number"
                  step="0.001"
                  v-model="row[hIndex]"
                  @input="parseValue($event, rIndex, hIndex)"
                  :ref="`val-row-${rIndex}`"
                  dense
                  hide-details
                  hide-spin-buttons
                  variant="plain"
                />
                <template v-else>{{ row[hIndex] }}</template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn text color="primary" @click="save()">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { deepClone } from "@/plugins/utils";

export default {
  name: "InputCoordinates",
  components: {},
  mixins: [],
  props: {
    value: { type: Array, required: true },
    headers: {
      type: Array,
      required: false,
      default: () => [
        { name: "Lat", editable: true },
        { name: "Lon", editable: true },
      ],
    },
  },
  data() {
    return {
      originalValue: undefined,
    };
  },
  computed: {
    tableValue: {
      get() {
        // Last null column to have an empty line
        return [...this.value, [null, null]];
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.originalValue = deepClone(this.value);
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    copyValues() {
      const excelData = this.value.join("\n").replaceAll(",", "\t");
      navigator.clipboard.writeText(excelData);
    },
    pasteValues() {
      navigator.clipboard.readText().then((clipText) => {
        const retrievedLines = clipText.split("\r\n");
        const retrievedTable = retrievedLines.map((row) => row.split("\t"));
        const tableValue = retrievedTable.filter((row) => row.length > 1);
        this.value.splice(0, this.value.length, ...tableValue);
      });
    },
    cancel() {
      this.value.splice(0, this.value.length, ...this.originalValue);
      this.$emit("close-dialog");
    },
    save() {
      const nonZeroValues = this.value.filter((row) =>
        row.every((value) => value !== 0 && value != null && value.length > 0)
      );
      this.value.splice(0, this.value.length, ...nonZeroValues);
      this.$emit("close-dialog");
      this.$emit("change");
    },
    parseValue(input, row, column) {
      if (this.value.length > row) {
        const rowValues = this.value[row];
        rowValues[column] = input;
        this.value.splice(row, 1, rowValues);
      } else {
        const newRow = Array(this.headers.length).fill(null);
        newRow.splice(column, 1, input);
        this.value.push(newRow);
        this.value.splice(row, 1, newRow);
      }
    },
  },
};
</script>

<style scoped>
.table {
  border-spacing: 5px;
}
</style>
